import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import 'chart.js/auto'; 

const DynamicDoughnutChart = ({ title, chartData, labels , colors = ['#A8372A', '#E8D2CB'] }) => {
    const totalData = chartData?.reduce((acc, value) => acc + value, 0);

    const data = {
        labels: labels,
        datasets: [
          {
            data: chartData,
            backgroundColor: ['#A8372A', '#E8D2CB'],
            hoverBackgroundColor: ['#A8372A', '#E8D2CB'],
            borderWidth: 0,
          },
        ],
      };
    
      const options = {
        cutout: '80%', 
        plugins: {
          legend: {
            display: false, 
          },
          tooltip: {
            enabled: false, 
          },
        },
      };


      const calculateFontSize = () => {
        const baseFontSize = 1.2; 
        const maxFontSize = 1.2; 
        const minFontSize = 0.8; 
        const length = totalData?.toString().length; 

        const dynamicFontSize = Math.max(minFontSize, maxFontSize - (length * 0.1));
        return `${dynamicFontSize}rem`;
    };
     
      const styles = {
        chartContainer: {
          backgroundColor: '#F8F8F8',
          padding: '20px',
          borderRadius: '15px',
        },
        dataContainer:{
            display: 'flex',
        },
        doughnutWrapper: {
          position: 'relative',
          width: '100px',
          height: '100px',
        },
        chartText: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: calculateFontSize(),
          fontWeight: 'bold',
          color: '#A8372A',
        },
        legend: {
          display: 'flex',
          width:"100%",
          flexDirection: 'column',
          justifyContent: 'center',
          marginLeft:"15px",
        },
        title: {
          marginBottom: '10px',
          width:"100%",
          color: '#333',
          fontWeight: 'bold',
        },
        legendItem: {
          display: 'flex',
          alignItems: 'center',
          marginBottom: '8px',
        },
        legendCircle: {
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          marginRight: '8px',
        },
        legendNumber: {
          marginLeft: 'auto',
          fontWeight: 'bold',
          color: '#A8372A',
        },
      };
      



  return <>
     <div style={styles.chartContainer}>
        <h5 style={styles.title}>{title}</h5>
        <div style={styles.dataContainer}>
      <div style={styles.doughnutWrapper}>
        <Doughnut data={data} options={options} />
        <div style={styles.chartText}>
          {totalData?  totalData?.toLocaleString() : 0}
        </div>
      </div>
       

      <div style={styles.legend}>
        {labels?.map((label, index) => (
          <div key={index} style={styles.legendItem}>
            <div
              style={{
                ...styles.legendCircle,
                backgroundColor: colors[index],
              }}
            ></div>
            <div className='w-100 d-flex justify-content-between'>
            <span>{label}</span>
            <span style={styles.legendNumber}>{chartData[index]?.toLocaleString() || 0} {title === "Admistritor Fees" && "EGP"}</span>
            </div>
          </div>
        ))}
      </div>
        </div>
    </div>
  </>

  
}

export default DynamicDoughnutChart